import React, { useState } from "react";
import { OpponentDisplay } from "../OpponentDisplay";
import { PlayerCardDialog } from "../players/PlayerCardDialog";
import { t } from "../../lib/i18n";

export const OpponentsRow = ({ opponents, clock, currentPlayerId, continuerId, playerColorMap, isHost, onReplaceWithBot }) => {
  // A tap on a player's pill opens their card (rank, record); no invitation from inside a game.
  const [cardOf, setCardOf] = useState(null);
  const positions =
    opponents.length === 1 ? ["top"] :
    opponents.length === 3 ? ["left", "top", "right"] : ["top"];

  return (
    <div className="shrink-0 px-1.5 min-[400px]:px-2 pt-3 pb-2 flex justify-around items-start gap-1.5 min-[400px]:gap-2 overflow-x-auto">
      {opponents.map((p, idx) => (
        <div key={p.user_id} className="min-w-0">
          <OpponentDisplay
            player={p}
            isActive={currentPlayerId === p.user_id}
            clock={clock?.userId === p.user_id ? clock : null}
            isContinuer={continuerId === p.user_id}
            position={positions[idx] || "top"}
            testId={`opponent-${p.user_id}`}
            color={playerColorMap?.[p.user_id]}
            isHost={isHost}
            onReplaceWithBot={onReplaceWithBot}
            onOpenProfile={setCardOf}
          />
        </div>
      ))}
      <PlayerCardDialog userId={cardOf} onClose={() => setCardOf(null)} inviteBlocked={t("players.finishGame")} />
    </div>
  );
};

export default OpponentsRow;
